export default {
  name: 'confirm-code',
  props: ['value'],
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    handleSubmit() {
      this.$emit('click', 'submit');
    },
    handleCancel() {
      this.$emit('click', 'cancel');
    },
  },
};
